import styled from 'styled-components'

export const TileCard = styled.div`
    cursor: pointer;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid #eef0f2;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    width: 100%;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 28px rgba(16, 24, 40, 0.12);
    }
`

export const CardBody = styled.div`
    padding: 2rem 1rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

export const AvatarCircle = styled.div`
    width: ${({ size }) => size || '90px'};
    height: ${({ size }) => size || '90px'};
    border-radius: 50%;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
    color: #2c3e50;
    font-size: 2.2rem;
    font-weight: 700;
    box-shadow: 0 2px 8px rgba(16, 24, 40, 0.08);
    border: 4px solid #ffffff;
`